<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '1200px', 'overflow': 'hidden'}"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  styleClass="all-points-chart-dialog">

  <div class="all-points-modal-header">
    <div class="header-content">
      <h2>{{ 'MONITORING_POINT' | translate }}</h2>
    </div>
    <button type="button" class="close-button" (click)="onClose()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="all-point-content-box">
    <div class="all-points-modal-content">
      <div class="points-chart-container">
        <div class="chart-area">
          @if (allPointsSelectedPoints.length === 0 || allPointsDataSource !== 'era5') {
            <div class="no-selection-message">
              @if (allPointsDataSource !== 'era5') {
                {{ 'INDEX_TILE_MAP.NO_DATA_AVAILABLE' | translate }}
              } @else {
                {{ 'NO_POINTS_SELECTED' | translate }}
              }
            </div>
          } @else {
            <app-svg-chart
              [chartData]="chartData"
              [config]="chartConfig"
              [isLoading]="isLoading"
              [noDataMessage]="errorMessage || ('NO_CHART_DATA' | translate)"
              [showLegend]="false"
            ></app-svg-chart>
          }
          <!-- Use app-svg-chart component -->


          <!-- Legend -->
          <div class="chart-legend" *ngIf="getLegendItems().length > 0">
            <div class="legend-item" *ngFor="let item of getLegendItems()">
              <span class="color-box" [style.background]="item.color"></span>
              <span>{{ formatLegend(item) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="all-points-modal-tabs">
      <div class="tab-group">
        <div class="tab-dropdown">
          <label class="dropdown-label">{{ 'POINT' | translate }}</label>
          <msf-multi-select
            [(model)]="allPointsSelectedPoints"
            [options]="allPointsOptions"
            [optionLabel]="'name'"
            [optionValue]="'id'"
            [placeholder]="'SELECT_POINT' | translate"
            [styleClass]="'all-points-point-select'"
            [panelStyleClass]="'all-points-point-select-panel'"
            [showClear]="true"
            [width]="'100%'"
            translateBy="none"
            (selectItem)="onPointsSelectionChange()">
          </msf-multi-select>
        </div>

        <div class="tab-dropdown">
          <label class="dropdown-label">{{ 'DATA_SOURCE' | translate }}</label>
          <msf-select
            [(model)]="allPointsDataSource"
            [options]="dataSourceOptions"
            [optionLabel]="'label'"
            [optionValue]="'id'"
            [placeholder]="'ERA5'"
            [width]="'100%'"
            (selectItem)="onDataSourceChange()">
          </msf-select>
        </div>

        <div class="tab-dropdown">
          <label class="dropdown-label">{{ 'WEATHER_INDICATOR' | translate }}</label>
          <msf-select
            [(model)]="allPointsWeatherIndicator"
            [options]="weatherLayerOptions"           
            [optionValue]="'id'"
            translateBy="names"
            [width]="'100%'"
            (selectItem)="onIndicatorChange()">
          </msf-select>           
        </div>

        <div class="tab-dropdown">
          <label class="dropdown-label">{{ 'PERIOD' | translate }}</label>
          <div class="date-range-inputs">
            <div class="date-input-group">
              <label class="date-label">{{ 'From' | translate }}</label>
              <app-date-picker
                [(ngModel)]="allPointsStartDate"
                [dateFormat]="'mm/yy'"
                [showIcon]="true"
                (onSelect)="onDateChange()"
                [ngStyle]="{'width':'100%'}"
                placeholder="MM/YY">
              </app-date-picker>
            </div>
            <div class="date-input-group">
              <label class="date-label">{{ 'To' | translate }}</label>
              <app-date-picker
                [(ngModel)]="allPointsEndDate"
                [dateFormat]="'mm/yy'"
                [showIcon]="true"
                (onSelect)="onDateChange()"
                [ngStyle]="{'width':'100%'}"
                placeholder="MM/YY">
              </app-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="all-points-modal-footer">
    <button pButton type="button" [label]="'CLOSE' | translate" class="close-btn" (click)="onClose()"></button>
  </div>
</p-dialog>
